import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { getSettingsSection, saveSettingsSection } from '../../../../services/settingsService';

function NotificationSettings() {
  const [notifications, setNotifications] = useState({
    emailNotifications: true,
    inAppNotifications: true,
    emailUpdates: {
      inspectionReminders: true,
      taskAssignments: true,
      systemUpdates: false
    },
    inAppUpdates: {
      inspectionReminders: true,
      taskAssignments: true,
      systemUpdates: true
    }
  });

  useEffect(() => {
    getSettingsSection('notifications')
      .then((data) => {
        if (data && Object.keys(data).length > 0) {
          setNotifications((prev) => ({ ...prev, ...data }));
        }
      })
      .catch(() => {});
  }, []);

  const handleToggleChange = (e) => {
    const { name, checked } = e.target;
    if (name.includes('.')) {
      const [category, setting] = name.split('.');
      setNotifications(prev => ({
        ...prev,
        [category]: { ...prev[category], [setting]: checked }
      }));
    } else {
      setNotifications(prev => ({ ...prev, [name]: checked }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await saveSettingsSection('notifications', notifications);
      toast.success('Notification settings saved');
    } catch (error) {
      toast.error(error.message || 'Failed to save notification settings', { autoClose: 4000 });
    }
  };

  return (
    <div className="stg-max-form">
      <div className="stg-page-header">
        <h1 className="stg-page-title">Notification Settings</h1>
        <p className="stg-page-subtitle">Control your email and in-app notification preferences.</p>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="stg-section">
          <h2 className="stg-section-title">Email Notifications</h2>
          <label className="stg-toggle-row">
            <input type="checkbox" name="emailNotifications" className="stg-toggle-checkbox" checked={notifications.emailNotifications} onChange={handleToggleChange} />
            <div className="stg-toggle-body">
              <span className="stg-toggle-label">Enable Email Notifications</span>
              <span className="stg-toggle-help">Receive email alerts for important events.</span>
            </div>
          </label>

          {notifications.emailNotifications && (
            <div className="stg-sub-options">
              <label className="stg-checkbox-label">
                <input type="checkbox" name="emailUpdates.inspectionReminders" checked={notifications.emailUpdates.inspectionReminders} onChange={handleToggleChange} />
                <span>Inspection Reminders</span>
              </label>
              <label className="stg-checkbox-label">
                <input type="checkbox" name="emailUpdates.taskAssignments" checked={notifications.emailUpdates.taskAssignments} onChange={handleToggleChange} />
                <span>Task Assignments</span>
              </label>
              <label className="stg-checkbox-label">
                <input type="checkbox" name="emailUpdates.systemUpdates" checked={notifications.emailUpdates.systemUpdates} onChange={handleToggleChange} />
                <span>System Updates</span>
              </label>
            </div>
          )}
        </div>

        <div className="stg-section">
          <h2 className="stg-section-title">In-App Notifications</h2>
          <label className="stg-toggle-row">
            <input type="checkbox" name="inAppNotifications" className="stg-toggle-checkbox" checked={notifications.inAppNotifications} onChange={handleToggleChange} />
            <div className="stg-toggle-body">
              <span className="stg-toggle-label">Enable In-App Notifications</span>
              <span className="stg-toggle-help">See alerts and updates within the platform.</span>
            </div>
          </label>

          {notifications.inAppNotifications && (
            <div className="stg-sub-options">
              <label className="stg-checkbox-label">
                <input type="checkbox" name="inAppUpdates.inspectionReminders" checked={notifications.inAppUpdates.inspectionReminders} onChange={handleToggleChange} />
                <span>Inspection Reminders</span>
              </label>
              <label className="stg-checkbox-label">
                <input type="checkbox" name="inAppUpdates.taskAssignments" checked={notifications.inAppUpdates.taskAssignments} onChange={handleToggleChange} />
                <span>Task Assignments</span>
              </label>
              <label className="stg-checkbox-label">
                <input type="checkbox" name="inAppUpdates.systemUpdates" checked={notifications.inAppUpdates.systemUpdates} onChange={handleToggleChange} />
                <span>System Updates</span>
              </label>
            </div>
          )}
        </div>

        <div className="stg-actions" style={{ justifyContent: 'flex-start' }}>
          <button type="submit" className="stg-btn stg-btn-primary">Save Changes</button>
        </div>
      </form>
    </div>
  );
}

export default NotificationSettings;
